import { request, success, failure, getMessage } from '../../helpers';
import { clientService } from '../../services';
import { appActions } from './app.actions';
import { clientBasicTypes } from '../types';

const getClientBasicInfo = (clientId, tenantId) => {
  return dispatch => {
    dispatch(request(clientBasicTypes.GET_CLIENT_BASIC_REQUEST));

    clientService.getClientBasicInfo(clientId, tenantId)
      .then(
        (clientInfo) => {
          if (!clientInfo.enabled) {
            throw { error: 'Client is disabled', code: 'client-disabled' };
          }
          dispatch({
            type: clientBasicTypes.GET_CLIENT_BASIC_SUCCESS,
            payload: clientInfo
          });
        },
        ({ error, code }) => {
          dispatch({
            type: clientBasicTypes.GET_CLIENT_BASIC_FAILURE,
            payload: error?.toString() ?? 'Invalid client'
          });

          getMessage(`client-basic-${code ?? 'error'}`, {
            message: error?.message ?? ''
          }).then((msg) => {
            dispatch(appActions.apiErrorMessage(msg));
          });
        }
      );
  };
};

export const clientActions = {
  getClientBasicInfo
};